"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDecimal = void 0;
const merge_1 = require("./util/merge");
const assertString_1 = require("./util/assertString");
const includes_1 = require("./util/includes");
const alpha_1 = require("./alpha");
function decimalRegExp(options) {
    const regExp = new RegExp(`^[-+]?([0-9]+)?(\\${alpha_1.decimal[options.locale]}[0-9]{${options.decimal_digits}})${options.force_decimal ?
        '' :
        '?'}$`);
    return regExp;
}
const default_decimal_options = {
    force_decimal: false,
    decimal_digits: '1,',
    locale: 'en-US',
};
const blacklist = ['', '-', '+'];
function isDecimal(str, options = {}) {
    (0, assertString_1.assertString)(str);
    const _options = (0, merge_1.merge)(options, default_decimal_options);
    if (_options.locale in alpha_1.decimal) {
        return !(0, includes_1.includes)(blacklist, str.replace(/ /g, '')) && decimalRegExp(_options).test(str);
    }
    throw new Error(`Invalid locale '${options.locale}'`);
}
exports.isDecimal = isDecimal;
